const dateTimeMixin = {
  methods: {
    formatDateTime(value) {
      return this.$moment(value).format("DD/MM/Y HH:mm:ss");
    },
    formatDate(value, defaultValue = "") {
      if (!value) {
        return defaultValue;
      }

      return this.$moment(value).format("DD/MM/Y");
    }
  }
};

export default dateTimeMixin;
